import * as React from "react"
import PropTypes from "prop-types"

import Header from "./header"
import Widget from "../common/widget"

const Layout = ({ children }) => (
  <>
    <Header />
    <div>
      <main>
        {children}
      </main>
    </div>
    <Widget />
  </>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout